// extracted by css-extract-rspack-plugin
export default {"floatingButton":"floating-button--yLSHMbtSpC0biZ3b"};